import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanEditUser = (): boolean => {
  const [canEditUser, setCanEditUser] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const editAllPermission: Permission = {
    resource: 'users',
    action: 'updatebasic',
    scope: 'all',
  };
  const editProviderPermission: Permission = {
    resource: 'users',
    action: 'updatebasic',
    scope: 'provider',
  };

  const canEditAll = useHasPermission(user, editAllPermission);
  const canEditProvider = useHasPermission(user, editProviderPermission);

  React.useEffect(() => {
    setCanEditUser(canEditAll || canEditProvider);
  }, [canEditAll, canEditProvider]);

  return canEditUser;
};
